export default __webpack_public_path__ + "static/media/expo-symbol-white-1x.7a743d3e.svg";